module.exports = __webpack_public_path__ + "img/join_vip_2.8064495f.png";